import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LanguageService } from './language.service';
import { UiService } from './ui.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./language.service";
import * as i3 from "./ui.service";
var CitizenService = /** @class */ (function () {
    function CitizenService(http, languageSrv, uiSrv) {
        this.http = http;
        this.languageSrv = languageSrv;
        this.uiSrv = uiSrv;
        this.citizenChanged = new Subject();
        this.baseUrl = environment.apiUrl + 'citizens';
    }
    CitizenService.prototype.get = function (organismCode) {
        var _this = this;
        this.uiSrv.routeLoadingStateChanged.next(true);
        return this.http.get(this.baseUrl + "/" + this.languageSrv.getCurrentLanguageCode() + "/" + organismCode)
            .pipe(tap(function (citizen) {
            _this.uiSrv.routeLoadingStateChanged.next(false);
            _this.citizenChanged.next(tslib_1.__assign({}, citizen));
        }));
    };
    CitizenService.ngInjectableDef = i0.defineInjectable({ factory: function CitizenService_Factory() { return new CitizenService(i0.inject(i1.HttpClient), i0.inject(i2.LanguageService), i0.inject(i3.UiService)); }, token: CitizenService, providedIn: "root" });
    return CitizenService;
}());
export { CitizenService };
